'use strict';

var _setup = require('./setup.js');

// List Filtering ---------------------------------------//

//ui / toggle behavior
var filtersOpened = false;
var filterIsOpening = false;

var doFilterdropUI = function doFilterdropUI(index, item) {
	var $this = $(item);
	var $btn = $this.find('.nx--filterdrop-btn');
	var $panel = $this.find('.nx-filterdrop--panel');
	var $activeText = $this.find('[data-text-alt]');
	var ogText = $activeText.text();
	var filterAlt = $activeText.data('text-alt');

	$btn.on('click', function () {
		if ($this.hasClass('filterdrop--open')) {
			TweenMax.to($panel, 0.1, { height: 0, ease: Expo.easeOut, onComplete: function onComplete() {
					if (filterAlt) {
						$activeText.text(ogText);
					}
				} });
			$this.removeClass('filterdrop--open filterdrop--opened');
			filtersOpened = false;
		} else {
			filterIsOpening = true;
			TweenMax.set($panel, { height: 'auto', autoAlpha: 1 });
			TweenMax.from($panel, 0.3, { height: 0, ease: Expo.easeOut, onComplete: function onComplete() {
					if (filterAlt) {
						$activeText.text(filterAlt);
					}
					$this.addClass('filterdrop--opened');
					setTimeout(function () {
						return filterIsOpening = false;
					}, 200);
				} });
			$this.addClass('filterdrop--open');
			filtersOpened = true;
		}
	});

	$panel.on('click', function (event) {
		return event.stopPropagation();
	});
};

if (_setup.s.$productFilterToggles) {
	//bind dropdown toggle
	_setup.s.$productFilterToggles.each(doFilterdropUI);
	//click-out to close behavior
	_setup.s.$doc.on('click', function () {
		if (filtersOpened && !filterIsOpening) {
			$('.filterdrop--open .nx--filterdrop-btn').trigger('click');
		}
	});
}

//filtering behavior -----------------------------------------------------------------------------//
var allFilteringBehavior = function () {
	var $chkbxPanel = $('#nx-filter-formcontrols');

	if ($chkbxPanel.length === 0) return;

	var $filterCount = $('#nx-filterdrop-activecount');
	var $parent = $chkbxPanel.parents('.nx--filterdrop');
	var $chkbxs = $chkbxPanel.find('input[type="checkbox"]');
	var $radios = $chkbxPanel.find('input[type="radio"]');
	var $clearBtn = $('.nx-filterdrop--clearbtn, .nx-nonefound--btn');
	var $promos = $('.nx-collectionlist--promo');

	var $promoItemsOuter = $('.nx-collectionlist--promoitems');
	var $promoItems = $promoItemsOuter.find('li[data-productlist-item="*"]');
	var $topGrid = _setup.s.$productIsogrids.first();

	var collectionType = $promoItemsOuter.data('collection-type');

	var isoInitOpts = {
		itemSelector: '[data-productlist-item]',
		layoutMode: 'packery',
		transitionDuration: 300,
		hiddenStyle: { opacity: 0, transform: 'scale(0.8)' },
		visibleStyle: { opacity: 1, transform: 'scale(1)'
			//getSortData: { price: isotopeSortData }
		} };

	var activeFilters = [];

	//is at least one filter active?
	var isFiltering = false;
	var notfoundShowing = false;
	var $iso = null;

	//every time filtering becomes active
	var onFilterEnabled = function onFilterEnabled() {
		$parent.addClass('is-filtering');
		_setup.s.$body.addClass('is-filteractive');
		$filterCount.text('(' + activeFilters.length + ')').show();

		$iso.isotope({ filter: isotopeFilterer });
	};

	//every time filtering is deactivated
	var onFilterDisabled = function onFilterDisabled() {
		$filterCount.hide();
		$promos.show();
		$parent.removeClass('is-filtering');
		_setup.s.$body.removeClass('is-filteractive');

		$iso.isotope({ filter: '*' });
		_setup.s.$doc.trigger('nx.productlist.showall');

		//close the open filter panel
		$('.filterdrop--open .nx--filterdrop-btn').trigger('click');
	};

	//only on switch from de-activated to active
	var onFilterFirstActive = function onFilterFirstActive() {
		var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

		$iso.isotope('destroy');
		$promos.hide();

		_setup.s.$productIsogrids.each(function (i) {
			if (i === 0) return;
			var $t = $(this);
			var $li = $t.find('[data-productlist-item]');
			$li.attr({ 'data-original-parent': i }).each(function (index) {
				var $this = $(this);
				$this.attr({ 'data-original-order': index });
				$this.detach().appendTo($topGrid);
			});
		});
		$iso.isotope(isoInitOpts);
		if (filter) {
			$iso.isotope({ filter: isotopeFilterer });
		}
	};

	//bound to customEvent 'nx.productlist.showall'
	var onFilterReverseActive = function onFilterReverseActive() {
		$iso.isotope('destroy');
		$promos.show();
		$topGrid.find('[data-original-parent]').each(function (i) {
			var $t = $(this);
			var $ogp = _setup.s.$productIsogrids.eq($t.data('original-parent'));
			$t.detach().appendTo($ogp);
		});

		var $allThings = _setup.s.$productIsogrids.add($promos);
		TweenMax.fromTo($allThings, 0.5, { autoAlpha: 0, y: 40 }, { autoAlpha: 1, y: 0, ease: Expo.easeOut });

		$iso.isotope(isoInitOpts);
	};

	//each checkbox's behavior
	var doFilterdropFilter = function doFilterdropFilter(index, item) {
		var $this = $(item);
		var name = $this.attr('name');

		$this.on('change', function () {
			var isChkd = $this.is(':checked');
			var isActive = activeFilters.indexOf(name) > -1;

			if (isChkd && !isActive) {
				activeFilters.push(name);
			} else if (isActive) {
				activeFilters.splice(activeFilters.indexOf(name), 1);
			}

			if (notfoundShowing && isActive) {
				TweenMax.to(_setup.s.$productNotFound, 0.2, { autoAlpha: 0, y: -40, ease: Expo.easeOut });
				notfoundShowing = false;
			}

			if (activeFilters.length === 0) {
				onFilterDisabled.call();
				isFiltering = false;
			} else {
				if (!isFiltering) {
					onFilterFirstActive();
				}
				onFilterEnabled.call();
				isFiltering = true;
			}
		});
	};

	//different behavior for radio buttons
	var doRadiosFilter = function doRadiosFilter(index, item) {
		var $this = $(item);
		var tag = $this.attr('value');

		$this.on('change', function () {
			activeFilters = [];
			activeFilters.push(tag);

			if (!isFiltering) {
				onFilterFirstActive();
				isFiltering = true;
			}
			onFilterEnabled.call();
		});
	};

	//put promo griditems in place
	var prepPromoGriditems = function prepPromoGriditems() {
		$promoItems.detach();

		_setup.s.$productIsogrids.each(function (index) {
			if (index + 1 === _setup.s.$productIsogrids.length) return;
			var $gridItems = $(this).find('li');

			var placementIndex = _setup.s.randomInt(2, 4);
			if (collectionType === 'Accessories') {
				placementIndex = _setup.s.randomInt(2, 7);
			}
			$promoItems.eq(index).insertAfter($gridItems.eq(placementIndex));
		});
	};

	//isotope filter function - checkboxes
	function isotopeFilterer() {
		var tag = $(this).data('productlist-item');
		var matches = [];
		activeFilters.forEach(function (item) {
			if (tag.indexOf(item) > -1) {
				matches.push(item);
			}
		});
		return matches.length === activeFilters.length;
	};

	//the 'getSortData' func for isotope
	var sortcounter = 0;
	function isotopeSortData(itemElem) {
		sortcounter++;
		var $pricetag = $(itemElem).find('[data-pricetag]');
		if ($pricetag.length === 0) {
			return 0;
		}
		var priceText = $pricetag.text();
		var priceFinal = parseInt(priceText.replace(/\D/g, ''));
		console.log(sortcounter + ' --- ' + priceFinal);
		return priceFinal;
	};

	//isotope arrangeComplete callback
	function isotopeArrangeComplete(e, items) {
		var isFirstGrid = $(e.currentTarget).data('isogrid') === 1;
		if (!isFirstGrid) return;

		if (items.length === 0 && !notfoundShowing) {
			TweenMax.fromTo(_setup.s.$productNotFound, 0.5, { autoAlpha: 0, y: 40 }, { autoAlpha: 1, y: 0, ease: Expo.easeOut });
			notfoundShowing = true;
		} else if (items.length > 0 && notfoundShowing) {
			TweenMax.to(_setup.s.$productNotFound, 0.2, { autoAlpha: 0, y: -40, ease: Expo.easeOut });
			notfoundShowing = false;
		}
	};

	//reset after checkbox filtering
	var clearCheckboxFilters = function clearCheckboxFilters() {
		return $chkbxs.each(function (index, item) {
			return $(item).removeAttr('checked').trigger('change');
		});
	};

	//reset after radio filtering
	var clearRadioFilters = function clearRadioFilters() {
		$radios.each(function (index, item) {
			return $(item).removeAttr('checked').trigger('change');
		});
		onFilterDisabled.call();
		isFiltering = false;
	};

	//initialize product filtering
	var initProductFiltering = function initProductFiltering() {
		//move promo items
		prepPromoGriditems();

		console.log('starting product filter -----** ');

		//start up isotope
		$iso = _setup.s.$productIsogrids.isotope(isoInitOpts);

		//on each isotope filter
		$iso.on('arrangeComplete', isotopeArrangeComplete);

		//on reverse active filter
		_setup.s.$doc.on('nx.productlist.showall', onFilterReverseActive);

		//initial layout setup
		$iso.isotope({ filter: '*' });

		//simpler logic for radio groups (currently no chkbxs)
		$radios.each(function (index, item) {
			return doRadiosFilter(index, item, $parent, $filterCount);
		});
		//only radios in use right now!
		//-------------------------------------------------------------------------------------//

		//each checkbox filter logic
		if ($chkbxs.length) {
			$chkbxs.each(function (index, item) {
				return doFilterdropFilter(index, item, $parent, $filterCount);
			});
		}

		//clear all btn
		$clearBtn.on('click', clearRadioFilters);
	};

	if (_setup.s.$productFilterToggles.length && _setup.s.$productIsogrids.length) {
		initProductFiltering.call();
	}
}();

// Collection sort dropdown active states --------------------------------//

var highlightActiveSort = function highlightActiveSort() {
	var $panel = _setup.s.$prdouctSortDrop.find('.nx-filterdrop--links');
	var $activeText = _setup.s.$prdouctSortDrop.find('.nx-filterdrop--active > span');
	var sortopts = ['', 'manual', 'title-ascending', 'title-descending', '', ''];
	var search = window.location.search !== undefined ? window.location.search : '?' + window.location.href.split('?')[1];
	var $activeItem = null;
	sortopts.forEach(function (item) {
		if (search === '' || search.indexOf('?page') === 0) {
			// this selector sets the default 'sort by' option
			$activeItem = $panel.find('a[href*="?sort_by=manual"]');
		} else if (search === '?sort_by=' + item) {
			$activeItem = $panel.find('a[href="?sort_by=' + item + '"]');
		}
	});
	if ($activeItem) {
		$activeText.text($activeItem.text());
		$activeItem.parent('li').addClass('is-current-item');
	}
};

if (_setup.s.$prdouctSortDrop.length) {
	highlightActiveSort();
}

// Item Hover Effect -----------------------------------------------------//

var itemHoverHandler = function itemHoverHandler(index, item) {
	var $this = $(item);
	var $parent = $this.find('.nx-productlist--item');
	var $stroke = $this.find('.nx-productlist--stroke');
	var hasstroke = !!$stroke.length;
	var $sides = $stroke.find('.stroke--side');
	var $top = {
		left: $stroke.find('.stroke--top-left'),
		right: $stroke.find('.stroke--top-right')
	};

	var $link = $this.find('.nx-productlist--link');
	var $btn = $this.find('.nx-productlist--btn button');
	var $shifted = $btn.add($sides);
	var $tops = $top.left.add($top.right);

	var $defimg = $this.find('.nx-productlist--defaultimg');
	var $openimg = $this.find('.nx-productlist--openimg');
	var hasOpenImg = !!$openimg.length;

	//const isPromo = $this.hasClass('.nx-productlist--ad');

	$link.hoverIntent(function () {
		$parent.addClass('is-hovering');
		if (!hasstroke) return;
		TweenMax.set($shifted, { autoAlpha: 1, y: '105%' });
		TweenMax.set($top.left, { autoAlpha: 1, x: '-105%' });
		TweenMax.set($top.right, { autoAlpha: 1, x: '105%' });
		TweenMax.to($shifted, 0.25, { y: '0%', autoAlpha: 1, ease: Expo.easeOut });
		TweenMax.to($tops, 0.5, { x: '0%', delay: 0.2, ease: Expo.easeOut });

		if (hasOpenImg) {
			TweenMax.set($defimg, { autoAlpha: 0 });
			TweenMax.set($openimg, { autoAlpha: 1 });

			// TweenMax.to($defimg, 0.35, {x:'100%'});
			// TweenMax.fromTo($openimg, 0.35, {x:'-100%',autoAlpha:1}, {autoAlpha:1, x:'0%'});
		}
	}, function () {
		$parent.removeClass('is-hovering');
		if (!hasstroke) return;
		TweenMax.to($tops, 0.1, { autoAlpha: 0 });
		TweenMax.to($shifted, 0.1, { autoAlpha: 0 });
		if (hasOpenImg) {
			TweenMax.set($defimg, { autoAlpha: 1 });
			TweenMax.set($openimg, { autoAlpha: 0 });
		}
	});
};

if (_setup.s.$productListItems.length) {
	_setup.s.$productListItems.each(itemHoverHandler);
}

// ImgLink Hover Efx ---------------------------------------------------------//

var imgLinkHover = function imgLinkHover(i, item) {
	var $this = $(item);
	var $anchor = $this.find('a');
	var $img = $this.find('img');
	var $line = $this.find('.nx-heading--sm-under');

	$anchor.hover(function () {
		TweenMax.set($line, { transformOrigin: 'right center' });
		TweenMax.to($img, 0.4, { scale: 1.05 });

		TweenMax.to($line, 0.325, { scaleX: 0, ease: Expo.easeOut, onComplete: function onComplete() {
				TweenMax.set($line, { transformOrigin: 'left center' });
				TweenMax.to($line, 0.325, { scaleX: 1, ease: Expo.easeOut });
			} });
	}, function () {
		TweenMax.to($img, 0.3, { scale: 1 });
	});
};

if (_setup.s.$productImgLinks.length) {
	_setup.s.$productImgLinks.each(imgLinkHover);
}


//////////////////
// WEBPACK FOOTER
// ./_js/product-lists.js
// module id = 15
// module chunks = 0